import { decode } from 'blurhash';
import React, { useEffect, useState } from 'react';

export default function BlurHashCanvas(props) {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    setDataUrl('');
    const { hash } = props;
    if (!hash) return;
    const width = Math.round(
      props.width > 1500 ? props.width / 15 : props.width / 10,
    );
    const height = Math.round(
      props.width > 1500 ? props.height / 15 : props.height / 10,
    );
    const punch = 1;
    const pixels = decode(hash, width, height, punch);
    const canvas = document.createElement('canvas'); // Dynamically Create a Canvas Element
    canvas.id = 'blurHashCanvas'; // Give the canvas an id
    canvas.width = width; // Set the width of the Canvas
    canvas.height = height; // Set the height of the Canvas
    canvas.style.display = 'none'; // Make sure your Canvas is hidden
    document.body.appendChild(canvas); // Insert the canvas into your page
    const c = document.getElementById('blurHashCanvas'); // Get canvas from page
    const ctx = canvas.getContext('2d');
    const imageData = ctx.createImageData(width, height);
    imageData.data.set(pixels);
    ctx.putImageData(imageData, 0, 0);
    const newDataUrl = c.toDataURL(); // This will save your image as a data url
    c.parentNode.removeChild(c);
    setDataUrl(newDataUrl);
  }, [props]);

  return (
    <>
      <div
        className="w-100"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0,0.2)),
            url("${dataUrl}")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          minHeight: props.height,
        }}
      >
        {props.children}
      </div>
    </>
  );
}
